import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { LeadKanbanCard } from './LeadKanbanCard';

export function LeadKanbanColumn({ id, title, leads, colorClass, onUpdate }) {
    const { isOver, setNodeRef } = useDroppable({
        id: id,
    });

    return (
        <div className="flex flex-col min-w-[320px] w-[320px] bg-[var(--bg-card)] border border-[var(--border-color)] rounded-2xl h-full max-h-[75vh]">
            <div className={`p-4 border-b border-[var(--border-color)] ${colorClass} rounded-t-2xl flex justify-between items-center bg-[var(--bg-main)]/50`}>
                <h3 className="font-black uppercase text-xs tracking-widest">{title}</h3>
                <span className="bg-[var(--bg-main)] px-2 py-1 rounded-md text-[10px] font-bold text-[var(--text-primary)]">{leads.length}</span>
            </div>
            
            <div 
                ref={setNodeRef} 
                className={`flex-1 overflow-y-auto p-4 transition-colors no-scrollbar space-y-4 ${isOver ? 'bg-[var(--accent-color)]/5' : ''}`}
            >
                {leads.map(lead => (
                    <LeadKanbanCard key={lead._id} lead={lead} colId={id} onUpdate={onUpdate} />
                ))}
                {leads.length === 0 && (
                    <div className="h-full flex flex-col items-center justify-center opacity-20 text-[10px] font-black uppercase tracking-widest text-center border-2 border-dashed border-[var(--border-color)] rounded-xl p-4 text-[var(--text-primary)]">
                        <span>Nenhum Lead<br/>Nesta Fase</span>
                    </div>
                )}
            </div>
        </div>
    );
}
